import React from "react";

const ALL_PROVIDERS = [
  {
    provider: "Anthropic",
    models: [
      { name: "Claude Opus 4",        id: "anthropic.claude-opus-4-20250514-v1:0",     tier: "premium",  inputPer1M: 15.00,  outputPer1M: 75.00  },
      { name: "Claude Sonnet 4.5",    id: "anthropic.claude-sonnet-4-5-20251101-v1:0", tier: "standard", inputPer1M: 3.00,   outputPer1M: 15.00  },
      { name: "Claude 3.7 Sonnet",    id: "anthropic.claude-3-7-sonnet-20250219-v1:0", tier: "standard", inputPer1M: 3.00,   outputPer1M: 15.00  },
      { name: "Claude 3.5 Sonnet v2", id: "anthropic.claude-3-5-sonnet-20241022-v2:0", tier: "standard", inputPer1M: 3.00,   outputPer1M: 15.00  },
      { name: "Claude 3.5 Haiku",     id: "anthropic.claude-3-5-haiku-20241022-v1:0",  tier: "fast",     inputPer1M: 0.80,   outputPer1M: 4.00   },
      { name: "Claude 3 Opus",        id: "anthropic.claude-3-opus-20240229-v1:0",     tier: "premium",  inputPer1M: 15.00,  outputPer1M: 75.00  },
      { name: "Claude 3 Haiku",       id: "anthropic.claude-3-haiku-20240307-v1:0",    tier: "fast",     inputPer1M: 0.25,   outputPer1M: 1.25   },
      { name: "Claude 2.1",           id: "anthropic.claude-v2:1",                     tier: "legacy",   inputPer1M: 8.00,   outputPer1M: 24.00  },
      { name: "Claude Instant",       id: "anthropic.claude-instant-v1",               tier: "legacy",   inputPer1M: 0.80,   outputPer1M: 2.40   },
    ],
  },
  {
    provider: "Amazon",
    models: [
      { name: "Nova Pro",           id: "amazon.nova-pro-v1:0",           tier: "standard", inputPer1M: 0.80,  outputPer1M: 3.20  },
      { name: "Nova Lite",          id: "amazon.nova-lite-v1:0",          tier: "fast",     inputPer1M: 0.06,  outputPer1M: 0.24  },
      { name: "Nova Micro",         id: "amazon.nova-micro-v1:0",         tier: "fast",     inputPer1M: 0.035, outputPer1M: 0.14  },
      { name: "Titan Text Premier", id: "amazon.titan-text-premier-v1:0", tier: "standard", inputPer1M: 0.50,  outputPer1M: 1.50  },
      { name: "Titan Text Express", id: "amazon.titan-text-express-v1",   tier: "legacy",   inputPer1M: 0.20,  outputPer1M: 0.60  },
    ],
  },
  {
    provider: "Meta",
    models: [
      { name: "Llama 3.3 70B",  id: "meta.llama3-3-70b-instruct-v1:0",  tier: "standard", inputPer1M: 0.72,  outputPer1M: 0.72  },
      { name: "Llama 3.2 90B",  id: "meta.llama3-2-90b-instruct-v1:0",  tier: "standard", inputPer1M: 0.72,  outputPer1M: 0.72  },
      { name: "Llama 3.2 11B",  id: "meta.llama3-2-11b-instruct-v1:0",  tier: "fast",     inputPer1M: 0.16,  outputPer1M: 0.16  },
      { name: "Llama 3.1 405B", id: "meta.llama3-1-405b-instruct-v1:0", tier: "premium",  inputPer1M: 5.32,  outputPer1M: 16.00 },
      { name: "Llama 3.1 70B",  id: "meta.llama3-1-70b-instruct-v1:0",  tier: "standard", inputPer1M: 0.99,  outputPer1M: 0.99  },
      { name: "Llama 3.1 8B",   id: "meta.llama3-1-8b-instruct-v1:0",   tier: "fast",     inputPer1M: 0.22,  outputPer1M: 0.22  },
    ],
  },
  {
    provider: "Mistral AI",
    models: [
      { name: "Mistral Large 2407", id: "mistral.mistral-large-2407-v1:0",    tier: "standard", inputPer1M: 3.00, outputPer1M: 9.00  },
      { name: "Mistral Large 2402", id: "mistral.mistral-large-2402-v1:0",    tier: "standard", inputPer1M: 4.00, outputPer1M: 12.00 },
      { name: "Mixtral 8x7B",       id: "mistral.mixtral-8x7b-instruct-v0:1", tier: "fast",     inputPer1M: 0.45, outputPer1M: 0.70  },
      { name: "Mistral 7B",         id: "mistral.mistral-7b-instruct-v0:2",   tier: "fast",     inputPer1M: 0.15, outputPer1M: 0.20  },
    ],
  },
  {
    provider: "Cohere",
    models: [
      { name: "Command R+",    id: "cohere.command-r-plus-v1:0",    tier: "standard", inputPer1M: 3.00, outputPer1M: 15.00 },
      { name: "Command R",     id: "cohere.command-r-v1:0",         tier: "fast",     inputPer1M: 0.50, outputPer1M: 1.50  },
      { name: "Command Light", id: "cohere.command-light-text-v14", tier: "legacy",   inputPer1M: 0.30, outputPer1M: 0.60  },
    ],
  },
  {
    provider: "AI21 Labs",
    models: [
      { name: "Jamba 1.5 Large", id: "ai21.jamba-1-5-large-v1:0", tier: "standard", inputPer1M: 2.00, outputPer1M: 8.00 },
      { name: "Jamba 1.5 Mini",  id: "ai21.jamba-1-5-mini-v1:0",  tier: "fast",     inputPer1M: 0.20, outputPer1M: 0.40 },
    ],
  },
  {
    provider: "GLM (z.ai)",
    models: [
      { name: "GLM-4 Plus",     id: "glm-4-plus",     tier: "standard", inputPer1M: 0.14,  outputPer1M: 0.14  },
      { name: "GLM-4 Flash",    id: "glm-4-flash",    tier: "fast",     inputPer1M: 0.015, outputPer1M: 0.015 },
      { name: "GLM-4 Air",      id: "glm-4-air",      tier: "fast",     inputPer1M: 0.105, outputPer1M: 0.105 },
      { name: "GLM-Z1 Preview", id: "glm-z1-preview", tier: "premium",  inputPer1M: 0.210, outputPer1M: 0.210 },
    ],
  },
];

const TIER_BADGE = {
  premium:  "bg-purple-100 text-purple-700",
  standard: "bg-blue-100 text-blue-700",
  fast:     "bg-green-100 text-green-700",
  legacy:   "bg-gray-100 text-gray-500",
};

function fmt(v) { return v < 0.01 ? "$" + v.toFixed(4) : "$" + v.toFixed(3); }

export default function Settings() {
  return (
    <div className="p-6 max-w-5xl mx-auto space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-1">System configuration and model pricing reference.</p>
      </div>

      {/* System info */}
      <section className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
        <h2 className="text-base font-semibold text-gray-800 mb-4">System Status</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          {[
            { label: "API Version", value: "v1.0" },
            { label: "Rate Limit", value: "1000 req/15 min" },
            { label: "Max Tokens / Request", value: "4 096" },
            { label: "Supported Providers", value: ALL_PROVIDERS.length + "" },
          ].map(({ label, value }) => (
            <div key={label} className="bg-gray-50 rounded-lg p-3">
              <p className="text-xs text-gray-400 mb-1">{label}</p>
              <p className="font-semibold text-gray-800 tabular-nums">{value}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing table per provider */}
      <section className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <h2 className="text-base font-semibold text-gray-800">Model Pricing Reference</h2>
          <p className="text-xs text-gray-400 mt-0.5">AWS Bedrock on-demand rates — USD per 1M tokens (2025). GLM prices are approximate.</p>
        </div>

        {ALL_PROVIDERS.map(({ provider, models }) => (
          <div key={provider}>
            <div className="px-5 py-2 bg-gray-50 border-y border-gray-100">
              <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">{provider}</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-xs text-gray-400 uppercase tracking-wide">
                  <tr>
                    <th className="px-5 py-2 text-left font-semibold">Model</th>
                    <th className="px-5 py-2 text-left font-semibold">Tier</th>
                    <th className="px-5 py-2 text-right font-semibold">Input /1M</th>
                    <th className="px-5 py-2 text-right font-semibold">Output /1M</th>
                    <th className="px-5 py-2 text-right font-semibold hidden md:table-cell">Input /1K</th>
                    <th className="px-5 py-2 text-right font-semibold hidden md:table-cell">Output /1K</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {models.map(m => (
                    <tr key={m.id} className="hover:bg-gray-50">
                      <td className="px-5 py-2.5">
                        <div>
                          <span className="font-medium text-gray-800">{m.name}</span>
                          <span className="block text-xs text-gray-400 font-mono mt-0.5">{m.id}</span>
                        </div>
                      </td>
                      <td className="px-5 py-2.5">
                        <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${TIER_BADGE[m.tier]}`}>{m.tier}</span>
                      </td>
                      <td className="px-5 py-2.5 text-right tabular-nums text-gray-700">{fmt(m.inputPer1M)}</td>
                      <td className="px-5 py-2.5 text-right tabular-nums text-gray-700">{fmt(m.outputPer1M)}</td>
                      <td className="px-5 py-2.5 text-right tabular-nums text-gray-400 hidden md:table-cell">{fmt(m.inputPer1M / 1000)}</td>
                      <td className="px-5 py-2.5 text-right tabular-nums text-gray-400 hidden md:table-cell">{fmt(m.outputPer1M / 1000)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
